import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import withFieldActions from '../withFieldActions';
import Checkbox from '../../../FormFields/Checkbox';
import ConfigService from "../../../../Services/api/Config";
import InputSelect from '../../../FormFields/Select';



export class UnitNumberWidget extends React.PureComponent {

  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>

          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, api } = this.props;
    const styleDescription = {
      color: ConfigService.getColor('secondaryColor'),
      textTransform: 'uppercase',
    };
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'Unit Number',
      className: 'WrapperWidget_Inline'
    };
    return (
      <WrapperWidget {...props}>
        <div className='UnitNumberWidget'>
          <div  className='Widget_Label'>
            <span className='Widget_Label_Description' style={ styleDescription }>{ value || (api ? api.getFieldsVerbiage(field, 'description') : field.description) }</span>
          </div>
        </div>
      </WrapperWidget>
    );
  }
}

export const UnitNumberWidgetEditable = withFieldActions(UnitNumberWidget);
